import { faCog, faFolder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { Button, ListGroup } from "react-bootstrap";
import { DateFormats } from "../../../../utilities/dates";
import { Project } from "../../../../models/Project";
import { useDispatch, useSelector } from "react-redux";
import * as GeneralStore from "../../../../store/general/General";
import { ApplicationState } from "../../../../store";
import { motion } from "framer-motion";
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

export interface ProjectListItemProps {
    data: Project;
    setProject?: (project: Project | null) => void;
}

function ProjectListItem(props: ProjectListItemProps) {
    const dispatch = useDispatch();
    const { general } = useSelector((state: ApplicationState) => state);
    const [isMouseOver, setIsMouseOver] = useState(false);

    const isSelected = general?.activeProjectId == props.data.projectId;

    function handleOnSelect(e?: React.SyntheticEvent) {
        e?.preventDefault();
        dispatch(GeneralStore.actionCreators.setActiveProject(props.data.projectId));
    }

    function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleOnSelect();
        }
    }

    return (
        <ListGroup.Item
            action
            as={motion.div}
            role="button"
            tabIndex={0}
            layout
            onClick={handleOnSelect}
            onKeyDown={handleKeyDown}
            onMouseEnter={() => setIsMouseOver(true)}
            onMouseLeave={() => setIsMouseOver(false)}
            className={`${isSelected ? "selected" : ""}`}
        >
            <motion.span layout className="gap-2 d-flex align-items-center text-truncate" title={props.data.name}>
                <FontAwesomeIcon icon={faFolder} />
                <motion.span layout className="text-truncate">
                    {props.data.name}
                </motion.span>
            </motion.span>
            <motion.span layout className="text-secondary">
                {isMouseOver && (
                    <Button
                        size="sm"
                        style={{ margin: "-2pt 0", padding: "0 0.5rem" }}
                        onClick={(e) => {
                            props.setProject?.(props.data);
                            e.stopPropagation();
                        }}
                    >
                        <FontAwesomeIcon fontSize={12} icon={faUserPlus} />
                    </Button>
                )}
            </motion.span>
            <motion.span layout className="text-secondary">
                {props.data.mediaCount}
            </motion.span>
            <motion.span layout className="text-secondary align-self-end">
                {dayjs(props.data.createdAt).format(DateFormats.yearMonthDayWithTime)}
            </motion.span>
        </ListGroup.Item>
    );
}

export default ProjectListItem;
